import React, { Component } from 'react';
import Modal from 'react-modal';
import { connect } from 'react-redux';
import createSelector from 'helpers/createSelector';
import { Switch, Icon, Table, Button, Row, Popconfirm, message, Alert } from 'antd';
import _ from 'lodash';
import { touchDownloadModal } from '../actions';
import download from 'helpers/downloadClipping';
import img2datauri from 'helpers/downloadClipping/img2datauri';
import config from 'config';
import sanitizeHtml from 'sanitize-html';
import moment from 'moment';
import striptags from 'striptags';
import * as notification from 'modules/notification';
import { logAsync } from 'helpers/elogAsync';
import { fetchDownLimit } from 'modules/elog/actions';
import Truncate from 'react-truncate-dom';
import classnames from 'classnames';
import clientId from 'clientId';

const userAgent = window.navigator.userAgent;

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.65)',
    zIndex: '999',
  },
  content: {
    position: 'absolute',
    left: '15%',
    right: '15%',
    top: '10%',
    bottom: null,
    border: '1px solid rgb(255, 255, 255)',
    background: '#EEEEF4',
    overflow: 'auto',
    borderRadius: '0px',
    outline: 'none',
    padding: '0px',
    zIndex: '999',
  }
};

const container = connect(
  createSelector(
    (state, props) => ({
      isOpen: _.get(state, 'collection.isOpen'),
      model: _.get(state, 'collection.clippingFeed'),
      globalIds: _.get(state, 'collection.globalIds'),
      userId: _.get(state, 'me.id'),
      permission: _.get(state, 'me.permission'),
      dayDownLimit: _.get(state, 'elog.dayDownLimit'),
    }),
    (state) => {
      const { model } = state
      return ({
        ...state,
      })
    }
  )
)

class DownloadModal extends Component {

  state = {
    loading: false,
    isDown: false,
    selected: [],
    isDownImg: [],
  }

  handleModalState = () => {
    const { dispatch } = this.props;
    dispatch(touchDownloadModal())
  }

  handleDownload = (type) => {
    const { model, globalIds, dispatch, permission } = this.props;
    this.setState({
      isDown: true
    })
    let downloadData;
    if (type === "part") {
      downloadData = _.flatMap(model.data, (d) => {
        if (_.includes(this.state.selected, d.globalId)) {
          return d
        } else {
          return []
        }
      })
    }
    if (type === 'all' || type === 'article') {
      downloadData = model.data
    }
    const then = this;
    const dataModel = _.map(downloadData, (d, i) => {
      i = parseInt(i)
      const div = document.createElement('div');
      div.innerHTML = d.content;
      let title, source, count, content, hits, comments, likes, shares, words;
      if (d.words) {
        words = `${t('commonWords')} ${d.words}`
      } else {
        words = ""
      }

      if (d.hits) {
        hits = `${t('commonHits')} ${d.hits}`
      } else {
        hits = ""
      }

      if (d.comments) {
        comments = `${t('commonComments')} ${d.comments}`
      } else {
        comments = ""
      }

      if (d.like) {
        likes = `${t('commonLikes')} ${d.likes}`
      } else {
        likes = ""
      }

      if (d.shares) {
        shares = `${t('commonShares')} ${d.shares}`
      } else {
        shares = ""
      }

      count = `${words} ${hits} ${comments} ${likes} ${shares}`;
      if (d.title) {
        title = `「${t(d.mediaType)}」${striptags(d.title).replace(/&nbsp;/ig, " ")}`
      } else {
        switch (d.mediaType) {
          case 'facebook':
            title = `「${t(d.mediaType)}」`;
            break;
          case 'twitter':
            title = `「${t(d.mediaType)}」`;
            break;
          case 'weibo':
            title = `「${t(d.mediaType)}」`;
            break;
          default:
            title = '「Untitled」'
        }
      }

      content = sanitizeHtml(div.innerHTML, {
        allowedTags: ['p', 'br'],
      })

      content = content
        .replace(/&nbsp;/ig, " ")
        .trim()
        .replace(/(<p>|<\/p>|<br>|<br\/>|<br \/>|\n\n\t|\n|\n\t)/ig, "<w:br/>")
        .replace(/^(<w:br\/>)+/, '')
        .replace(/(<w:br\/>){3,}/ig, '<w:br/><w:br/>')

      content = `<w:p><w:r><w:t>${content}</w:t></w:r></w:p>`

      if (d.from && d.in && d.by) {
        source = `${d.from} - ${d.in} - ${d.by} ${moment(d.date).format('YYYY-MM-DD HH:mm')}`
      } else if (d.from && d.in) {
        source = `${d.from} - ${d.in} ${moment(d.date).format('YYYY-MM-DD HH:mm')}`
      } else if (d.from) {
        source = `${d.from} ${moment(d.date).format('YYYY-MM-DD HH:mm')}`
      } else {
        source = ` ${moment(d.date).format('YYYY-MM-DD HH:mm')}`
      }

      let images;
      if (type === "part") {
        if (_.includes(this.state.isDownImg, d.globalId)) {
          images = Array.prototype.map.call(div.querySelectorAll('img'), function (img) {
            const src = img.getAttribute('data-src') || img.src;
            return config.utility.baseUrl + '/image?url[url]=' + encodeURIComponent(src) + '&url[headers][User-Agent]=' + encodeURIComponent(userAgent);
          });
        }
      }
      if (type === "all") {
        images = Array.prototype.map.call(div.querySelectorAll('img'), function (img) {
          const src = img.getAttribute('data-src') || img.src;
          return config.utility.baseUrl + '/image?url[url]=' + encodeURIComponent(src) + '&url[headers][User-Agent]=' + encodeURIComponent(userAgent);
        });
      }
      return img2datauri(images)
        .then(function (images) {
          return ({
            index: i + 1,
            title, source, content, count,
            url: d.url,
            images,
          })
        }
      )
    })
    const company = t('companyErs');
    const companyShort = t('companyErsShort');
    const copyright = moment().format('YYYY');
    const downData = _.compact(dataModel)
    Promise.all(downData)
      .then(function (downData) {
        then.setState({
          isDown: false,
          selectedRowKeys: [],
          downloadImage: []
        })
        if (_.get(permission, 'favoriteQuota.localStorage')) {
          localStorage.downLimit = parseInt(_.get(localStorage, 'downLimit', 0)) + _.get(downData, 'length', 0)
          localStorage.downTime = moment().format('YYYY-MM-DD')
        } else {
          const { email } = localStorage;
          const logData = {
            limit: _.get(downData, 'length', 0),
            globalIds: globalIds,
            user: email,
          }
          logAsync({
            type: "sPOP-collection-download",
            data: logData,
          })
        }
        let fileName = `eRS-sPOP-${moment().format('YYYYMMDD')}.docx`;
        if (clientId) {
          fileName = `uMaxData-sPOP-${moment().format('YYYYMMDD')}.docx`;
        }
        download({
          feed: downData,
          copyright,
          company,
          companyShort,
          footerInfo1: t('footerInfo1'),
          footerInfo2: t('footerInfo2'),
        }, fileName, 'template.docx')
      })
      .then(() => {
        const { email } = localStorage;
        dispatch(fetchDownLimit({
          startDate: moment().format('YYYY-MM-DD 00:00:00'),
          endDate: moment().format('YYYY-MM-DD 23:59:59'),
          limit: 20,
          data: JSON.stringify({ user: email })
        }
        ))
      })
  }

  constDataSoure = (data) => {
    const dataSource = _.map(data, (d, i) => {
      return {
        ...d,
        key: i
      }
    })
    return dataSource
  }
  constRowSelection = () => {
    const then = this;
    const rowSelection = {
      onChange(selectedRowKeys, selectedRows) {
        const selected = _.map(selectedRows, 'globalId')
        then.setState({
          selected: selected,
        })
      },
    };
    return rowSelection
  }
  constColumns = () => {
    const than = this;
    const columns = [
    {
      title: t('commonTitle'),
      dataIndex: 'title',
      key: 'title',
      render: (data, record) => {
        let showContent = '';
        if (!_.isEmpty(record.title)) {
          showContent = record.title.replace(/<[^>]+>/g,"")
        } else {
          if (!_.isEmpty(record.content)) {
            showContent = record.content.replace(/<[^>]+>/g,"")
          }
        }
        return (
          <span title={showContent}>
            <Truncate
              line={1}
              html={showContent}
            />
          </span>
        )
      }
    },
    {
      title: <div className="text-right">
        <span className="margin-right-md">是/否下載圖片</span>
        <Switch
          checkedChildren={<Icon type="check" />}
          unCheckedChildren={<Icon type="cross" />}
          onChange={(check) => {
            const {globalIds} = than.props;
            if (check) {
              this.setState({
                isDownImg: globalIds
              })
            } else {
              this.setState({
                isDownImg: []
              })
            }
          }} />
        </div>,
      key: 'operation',
      className: 'text-right',
      width: 170,
      render: (data, record) => {
        return(
          <span>
            <Switch
              checkedChildren={<Icon type="check" />}
              unCheckedChildren={<Icon type="cross" />}
              checked={
                _.includes(this.state.isDownImg, record.globalId)
              }
              onChange={(check) => {
                const globalId = record.globalId;
                if (check) {
                  than.setState({
                    isDownImg: [...than.state.isDownImg , globalId]
                  })
                } else {
                  than.setState({
                    isDownImg: _.reject(than.state.isDownImg, (n) => {return n == globalId})
                  })
                }
              }} />
          </span>)
      }
    }];
    return columns
  }

  render() {
    const { isOpen, model, loading, dayDownLimit, globalIds, permission } = this.props;
    const rowSelection = this.constRowSelection();
    const columns = this.constColumns();
    const data = this.constDataSoure(model.data);
    let overplus = 50-dayDownLimit;
    if (_.get(permission, 'favoriteQuota.localStorage')) {
      overplus = 50 - parseInt(_.get(localStorage, 'downLimit', 0))
    }
    return (
      <Modal
        isOpen={isOpen}
        closeTimeoutMS={150}
        style={styles}
        onRequestClose={() => this.handleModalState()}
      >
        <button className="pull-right margin-right-md model-close-button" onClick={() => this.handleModalState()}><Icon type="cross" /></button>
        <div style={{padding: "25px 30px 30px 30px"}}>
          {this.state.isDown &&
            <Alert className="pull-left" message="圖片下載中，請稍後..." type="info" showIcon />
          }
          <div className="margin-bottom-md" style={{textAlign: 'right'}}>
            {false &&
              <Popconfirm
                placement="top"
                title="請選擇下載類型"
                onCancel={() => {
                  if (_.get(globalIds, 'length') > overplus ) {
                    notification.info(
                    <div>
                      <p>您的下載量已超過限額</p>
                      <p>如需要更多數據，請聯繫我們</p>
                      <a href="mailto:service@ersinfotech.com">service@ersinfotech.com</a>
                    </div>
                    )
                  } else {
                    this.handleDownload('article')
                  }
                }}
                onConfirm={() => {
                  if (_.get(globalIds, 'length') > overplus ) {
                    notification.info(
                    <div>
                      <p>您的下載量已超過限額</p>
                      <p>如需要更多數據，請聯繫我們</p>
                      <a href="mailto:service@ersinfotech.com">service@ersinfotech.com</a>
                    </div>
                    )
                  } else {
                    this.handleDownload('all')
                  }
                }}
                okText="含圖下載"
                cancelText="僅下載文字"
                >
                <Button
                  className="margin-right-md pull-left"
                  type="primary"
                  loading={this.state.isDown}
                  // onClick={() => this.handleDownload('all')}
                  >
                    {t('commonAll')} {t('commonDownload')}
                </Button>
              </Popconfirm>
            }
            <Button
              type="primary"
              loading={this.state.isDown}
              onClick={() => {
                if(_.isEmpty(this.state.selected)) {
                  return message.warning('閣下還未選擇需下載的內容');
                }
                if (_.get(this.state.selected, 'length', 0) > overplus ) {
                  notification.info(
                  <div>
                    <p>您的下載量僅剩餘{overplus}條</p>
                    <p>當前選擇已超過限額</p>
                    <p>如需要更多數據，請聯繫我們</p>
                    <a href="mailto:service@ersinfotech.com">service@ersinfotech.com</a>
                  </div>
                  )
                } else {
                  this.handleDownload('part')
                }
              }}
              >
                <Icon type="download" className={classnames({"opacity-z": this.state.isDown})}></Icon>
                {t('commonDownload')}
            </Button>
          </div>
          <div className="down-table">
            <Table
              size="small"
              rowSelection={rowSelection}
              columns={columns}
              dataSource={data}
              scroll={_.get(data, 'length') > 10 ? { y: 360 } : false}
              pagination={false}/>
          </div>
        </div>

      </Modal>
    )
  }
}

export default container(DownloadModal)



/** WEBPACK FOOTER **
 ** ./src/app/modules/collection/components/DownloadModal.js
 **/